import React, { useEffect, useState } from 'react';
// import { Badge } from '../../../../components/Icons';
import { Redux, Slices } from 'spwa-ui-library';
import Button from '@material-ui/core/Button';
import { useIntl } from 'react-intl';
import css from './index.module.scss';
import header from './images/header.svg';
import { binViewPopUp, binProceedPopUp } from 'spwa-ui-library/esm/utils/helperGA';
const { useSelector, useDispatch } = Redux;

const { selectCurrentCountry } = Slices.profileSlice;
const { selectCountryValidations, selectPaymentMethodConstants } = Slices.configSlice;
const BinPromotion = ({
  paymentMethod,
  setBinPromoPopup,
  setSelectedMethod,
  selectedMethod,
  setSelectedMode,
  handlePayment,
  makePayment,
  binSavedCard,
  setSelectedCard,
  setCardNumber,
  handleCardToken,
  cardList,
}) => {
  const cart = useSelector((state) => state.cart);
  const { couponCode } = cart.data.promo;
  const discount = cart.data.amount?.filter((val) => val.type === 'DISCOUNT');
  const total = cart.data.amount?.filter((val) => val.type === 'TOTAL');
  const calculated = discount[0]?.amount + total[0].amount;
  const country = useSelector(selectCurrentCountry);
  const intl = useIntl();
  const paymentMethodConst = useSelector(selectPaymentMethodConstants);
  const countryValidations = useSelector((state) => selectCountryValidations(state, country));
  const filterMethod = paymentMethod.filter((itm) => itm.id === selectedMethod);
  const PromoMethod = paymentMethod.filter((itm) => itm.id === cart.data.promo.paymentMethod);

  const handleWithDiscount = () => {
    setSelectedMode(cart.data.promo.paymentMethod);
    handlePayment(cart.data.promo.paymentMethod);
    setBinPromoPopup((prev) => false);
    makePayment();
    binProceedPopUp('GetDiscount', cart.data.promo.paymentMethod);
  };
  const noDiscount = () => {
    if (!binSavedCard) {
      setSelectedMode((prev) => selectedMethod);
      handlePayment((prev) => selectedMethod);
      setBinPromoPopup((prev) => false);
      binProceedPopUp('ProceedWithSame', selectedMethod);
      setTimeout(() => {
        makePayment(selectedMethod);
      }, 500);
    } else {
      setSelectedCard((prev) => binSavedCard.tokenId);
      setCardNumber((prev) => binSavedCard.cardNumber);
      handlePayment((prev) => null);
      handleCardToken((prev) => binSavedCard.tokenId);
      setSelectedMode((prev) => null);
      binProceedPopUp('ProceedWithSame', 'Saved Card');
      setTimeout(() => {
        makePayment(selectedMethod, binSavedCard.tokenId);
      }, 500);
    }
  };

  const fetchPaymentMethodName = (id) => {
    const op = paymentMethodConst.filter((each) => {
      return each.name === id;
    });
    return op[0]?.value;
  };
  const getCardDetail = (cardTo) => {
    const op = cardList.filter((each) => {
      return each.token === cardTo;
    });
    return op[0]?.brand;
  };
  const selectedPaymentName = binSavedCard
    ? getCardDetail(binSavedCard.tokenId)
    : fetchPaymentMethodName(filterMethod[0]?.name);
  useEffect(() => {
    binViewPopUp(selectedPaymentName);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <>
      <div className={css.root}>
        {/* <div className={css.badge}>
          <Badge />
        </div> */}
        <div className={css.img}>
          <img src={header} alt="sure" />
        </div>
        <div className={css.couponText}>
          {intl.formatMessage(
            { id: 'binpromotion_heading' },
            {
              selectedPaymentName,
              couponCode,
            }
          )}
          <span>
            {calculated} {countryValidations.currency}
          </span>
          {/* Selecting {selectedPaymentName} will remove {couponCode} & the amount will be{' '}
           */}
        </div>
        <div className={css.cta}>
          <Button onClick={handleWithDiscount} variant="contained" color="primary">
            <div> {intl.formatMessage({ id: 'binpromtion_get_discount' })}</div>
            <div className={css.subHeading}>
              ({intl.formatMessage({ id: 'binpromotion_pay_via' })}{' '}
              {fetchPaymentMethodName(PromoMethod[0]?.name)})
            </div>
          </Button>
        </div>
        <div className={css.ctaSecondry}>
          <Button onClick={noDiscount}>
            {' '}
            {intl.formatMessage(
              { id: 'binpromotion_procceed' },
              {
                selectedPaymentName,
              }
            )}
          </Button>
        </div>
      </div>
    </>
  );
};
export default BinPromotion;
